import React from "react";
import UploadFile from "../../FormFields/UploadFile";

const MessageA21 = (props) => {
  props?.setEnableAttachment(true)
  props?.setCodeValue?.(props.item?.code)
  return <UploadFile ref={props.uploadRef}   {...props} />;
};

export default MessageA21;
